"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-screen w-full bg-gradient-to-b from-primary to-accent flex items-center justify-center px-4 py-16">
      <div className={`max-w-4xl w-full flex flex-col items-center text-center space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <SafeHydrate><Avatar className="size-24 border-2 border-white/20 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:rotate-2">
          <AvatarImage src="https://profound-bir.10web.cloud/wp-content/uploads/2026/01/Logo.png" alt="JokerStudio" />
          <AvatarFallback className="bg-primary-dark text-foreground-primary text-2xl font-display">
            JS
          </AvatarFallback>
        </Avatar></SafeHydrate>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground-primary leading-tight">
          Capturer chaque moment
        </h1>

        <p className="text-base md:text-lg lg:text-xl text-secondary max-w-2xl leading-relaxed">
          Vidéographie, photographie et services DJ professionnels pour vos événements à Montréal
        </p>

        <Link to="/ServicesPage">
          <Button size="lg" className="mt-4 bg-white text-primary hover:bg-white/90 hover:scale-103 active:scale-100 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] shadow-medium">
            Découvrir nos services
          </Button>
        </Link>
      </div>
    </section>;
}